module.exports = __webpack_public_path__ + "assets/img/26_1583_big.79011932.jpg";